import { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import { useSignupContext } from "../../../../../../hooks/useSignupContext.shared";
import { preserveScrollRestorationState } from "../../../../../../utils/scrollRestoration";
import { StorefrontTableCategoryDialogContainer } from "./StorefrontTableCategoryDialogContainer";

export const StorefrontRouteProductDialog = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signupDialogActive } = useSignupContext();
  const productId = Number(searchParams.get("categoryId"));
  const active = productId > 0 && !signupDialogActive;
  const dismiss = useCallback(() => {
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete("categoryId");
    navigate(
      {
        pathname: location.pathname,
        search: nextSearchParams.toString(),
      },
      {
        preventScrollReset: true,
        replace: true,
        state: preserveScrollRestorationState(location),
      },
    );
  }, [location, navigate, searchParams]);

  if (productId <= 0) return null;

  return (
    <StorefrontTableCategoryDialogContainer
      productId={productId}
      active={active}
      onDismiss={dismiss}
    />
  );
};
